import styled from 'styled-components'

const StSelectContainer = styled.select`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 1;

  transition: all 0.3s ease;

  ${({ theme }) => {
    return `
      padding: ${theme.UI.SpacingPx.Space3} ${theme.UI.SpacingPx.Space4};
      background-color: ${theme.Components.Input.Fill};
      border: 1px solid ${theme.Components.Input.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      color: ${theme.Components.Input.Text};

      > input {
        width: 100%;
        padding: ${theme.UI.SpacingPx.Space4};
      }

      &:focus-within {
        outline: none;
        border-color: ${theme.Components.Input.ActiveBorder};
        background-color: ${theme.Components.Input.ActiveFill};
      }
    `
  }}
`

export { StSelectContainer }
